import React, { useEffect, useState } from 'react'

export const ChuGiaiThichHop = (props) => {
    const [listChuGiais, setListChuGiai] = useState([]);
    useEffect(() => {
        setListChuGiai(props.listChuGiais);
    }, [props.listChuGiais]);
    const clickRow = (item) => {
        item.Checked = !item.Checked;
        setListChuGiai([...listChuGiais]);
        props.clickChuGiai(listChuGiais.filter(x => x.Checked).map(x => "'" + x.matn + "'").join(','));
    }
    return (
        <table className="table table-bordered tb-chu-giai" width="100%">
            <thead>
                <tr>
                    <th rowSpan="2" className="col-checkbox"></th>
                    <th rowSpan="2" className="mau-ky-hieu">Màu sắc Ký hiệu</th>
                    <th colSpan="17">THÍCH HỢP ĐẤT ĐAI VỚI CÁC CÂY TRỒNG</th>
                </tr>
                <tr>
                    <th>Lúa</th>
                    <th>Ngô</th>
                    <th>Sắn</th>
                    <th>Khoai</th>
                    <th>Rau</th>
                    <th>Hoa</th>
                    <th>Bí</th>
                    <th>Lạc</th>
                    <th>Cam</th>
                    <th>Bưởi</th>
                    <th>Chanh dây</th>
                    <th>Nhãn</th>
                    <th>Mít</th>
                    <th>Bơ</th>
                    <th>Sầu riêng</th>
                    <th>Xoài</th>
                    <th>Na</th>
                    <th>Chuối</th>
                    <th>Điều</th>
                    <th>Cao su</th>
                    <th>Hồ tiêu</th>
                    <th>Caffe</th>
                    <th>Dâu tằm</th>
                    <th>Măng tây</th>
                    <th>Dừa</th>
                    <th>Dược liệu</th>
                </tr>
            </thead>
            <tbody>
                {
                    listChuGiais?.map((item, key) => {
                        return (
                            <tr onClick={() => clickRow(item)} key={key}>
                                <td className="col-checkbox">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={item.Checked} readOnly />
                                    </div>
                                </td>
                                <td className="mau-ky-hieu">
                                    <div style={{ backgroundColor: item.mamau }}>
                                        <span>{item.matn}</span>
                                    </div>
                                </td>
                                <td>{item.thlua}</td>
                                <td>{item.thngo}</td>
                                <td>{item.thsan}</td>
                                <td>{item.thkhoai}</td>
                                <td>{item.thrau}</td>
                                <td>{item.thhoa}</td>
                                <td>{item.thbi}</td>
                                <td>{item.thlac}</td>
                                <td>{item.thcam}</td>
                                <td>{item.thbuoi}</td>
                                <td>{item.thchanhday}</td>
                                <td>{item.thnhan}</td>
                                <td>{item.thmit}</td>
                                <td>{item.thbo}</td>
                                <td>{item.thsaurieng}</td>
                                <td>{item.thxoai}</td>
                                <td>{item.thna}</td>
                                <td>{item.thchuoi}</td>
                                <td>{item.thdieu}</td>
                                <td>{item.thcaosu}</td>
                                <td>{item.thtieu}</td>
                                <td>{item.thcaffe}</td>
                                <td>{item.thdautam}</td>
                                <td>{item.thmangtay}</td>
                                <td>{item.thdua}</td>
                                <td>{item.thduoclieu}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}
